import { EVENTS } from '@/features/events';

export interface NavItem {
  readonly label: string;
  readonly to: string;
}

/**
 * Navegacion del sitio. Los destinos salen de la config tipada: si manana
 * cambia un slug, el menu cambia solo. Nadie teclea una ruta a mano.
 *
 * ROTULO CORTO DESDE EL 23-sep-2026, Y NO POR GUSTO. Con la entrada de Funes la
 * barra pasa a SIETE enlaces, y medido en un Chromium a 1024 px el ultimo
 * («CANCÚN / RIVIERA MAYA») pisaba la capsula de WhatsApp por 48 px — lo cazo
 * el gate de solape de `responsive-y-a11y.spec.ts`, que existe justo para esto.
 * `shortName` NO es un nombre nuevo: es el mismo toponimo en corto que ya usan
 * las fichas del hub y el pie del poster, y con el la fila vuelve a caber.
 */
export const NAV_DESTINATIONS: readonly NavItem[] = EVENTS.map((event) => ({
  label: event.shortName,
  to: event.path,
}));

export const NAV_PRIMARY: readonly NavItem[] = [{ label: 'La gira', to: '/' }, ...NAV_DESTINATIONS];

const WHATSAPP_E164 = '34722293967';

/**
 * Contacto por WhatsApp (peticion del cliente, 3-ago-2026).
 *
 * `href` se compone del numero en E.164 SIN el `+` ni espacios, que es lo unico
 * que acepta `wa.me`: con el `+` delante o con separadores, WhatsApp abre pero
 * NO precarga la conversacion, y el visitante acaba en la pantalla de buscar
 * contacto. El `display` es el mismo numero para leerlo, y esta aqui —no en el
 * componente— para que el rotulo accesible y el destino no puedan divergir.
 */
export const WHATSAPP = {
  e164: WHATSAPP_E164,
  display: '+34 722 29 39 67',
  href: `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent('Hola, quiero información sobre la Gira 2027.')}`,
} as const;

/**
 * Los mismos destinos con el rotulo CORTO del dato (`shortName`).
 *
 * No es un rotulo nuevo ni inventado: `shortName` ya existe en la config tipada y
 * es lo que usa `DestinationCard` en las fichas del hub. Aqui hace falta porque el
 * pie del poster compone su navegacion en UNA fila, y con los nombres largos no
 * cabe: medidos a 1024, los cinco rotulos de `city` suman 550 px de texto y la
 * columna central del pie da 560 px, asi que la fila se partia en 3/1/1 (y en 4/1 a
 * 1280 y 1440). Con `shortName` el texto baja a ~337 px y la fila unica es real.
 *
 * `NAV_DESTINATIONS` se queda EXACTAMENTE como estaba: la cabecera no cambia de
 * rotulos por esto.
 */
export const NAV_DESTINATIONS_SHORT: readonly NavItem[] = EVENTS.map((event) => ({
  label: event.shortName,
  to: event.path,
}));
